import { type ActionFunctionArgs, type LoaderFunctionArgs, replace } from "react-router-dom";
import type { CurvesFormState, FormState } from "../types";
import CurvesForm, { curvesLoader, CurvesSignupErrorBoundary } from "./curves/CurvesForm.tsx";
import Error from "./error/Error.tsx";
import MarketOutlookForm, {
  MarketOutlookErrorBoundary,
  marketOutlookLoader,
} from "./marketOutlook/marketOutlookForm.tsx";
import Success from "./success/Success.tsx";
import { defaultActionForm } from "./utils/defaultActionForm.ts";

export const routes = [
  {
    path: "/",
    ErrorBoundary: Error,
    children: [
      {
        index: true,
        loader: ({ request }: LoaderFunctionArgs) => {
          return replace(`/marketoutlook${new URL(request.url).search}`);
        },
      },
      {
        path: "marketoutlook",
        id: "marketOutlook-signup",
        action: async (args: ActionFunctionArgs) => {
          const { errors, formState } = await defaultActionForm<FormState>(args);
          return { errors, formState };
        },
        loader: marketOutlookLoader,
        ErrorBoundary: MarketOutlookErrorBoundary,
        element: <MarketOutlookForm />,
      },
      {
        path: "curves",
        id: "curves-signup",
        action: async (args: ActionFunctionArgs) => {
          const { errors, formState } = await defaultActionForm<CurvesFormState>(args);
          return { errors, formState };
        },
        loader: curvesLoader,
        ErrorBoundary: CurvesSignupErrorBoundary,
        element: <CurvesForm />,
      },
      {
        path: "success",
        element: <Success />,
      },
      {
        path: "error",
        element: <Error />,
      },
    ],
  },
];
